import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardContent, Grid } from '@material-ui/core';
import styles from 'styles/admin-detail.module.scss';
import {
  AFTER_CURRENT_PURPOSE,
  APPLICABLE_CHECK,
} from 'const';
import { getStylesBackgroundColor} from 'views/Detail/components';
import { getStylesLabelColorLine} from 'views/Detail/components';

const PurposeDetail = (props) => {
  const { purpose, insuranceType } = props;

  return (
    <Card>
      <CardHeader
        title='使用目的変更'
        className={getStylesBackgroundColor(insuranceType)}
      />
      <CardContent className={styles.cardContent}>
        <Grid container spacing={5}>
          <Grid item xs={2}>
            <div>
              <p className={getStylesLabelColorLine(insuranceType)}>変更後の使用目的</p>
              <p className={styles.text}>
                {purpose?.afterCurrentPurpose
                  ? AFTER_CURRENT_PURPOSE[purpose.afterCurrentPurpose]
                  : '-'}
              </p>
            </div>
          </Grid>
          <Grid item xs={2}>
            <div>
              <p className={getStylesLabelColorLine(insuranceType)}>業務専用車有無</p>
              <p className={styles.text}>
                {purpose?.forBusinessUseCar
                  ? APPLICABLE_CHECK[purpose.forBusinessUseCar]
                  : '-'}
              </p>
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

PurposeDetail.propTypes = {
  className: PropTypes.string,
};

export default PurposeDetail;
